export default function Footer() {
  return (
    <footer className="footer">
      <div className="container px-6 py-8">
        <div className="row">
          <div className="col-12 col-md-4 mb-3">
            <a className="navbar-brand fw-bold col-auto text-decoration-none" href="/">
              <span className="logo"><img src="images/ProfitPalmAgency_logo.svg" alt="ProfitPalm Agency"/> </span>
            </a>
          </div>
          <div className="col-12 col-md-4 mb-2 text-center">
            <h4 className="font-bold">Navigation</h4>
            <ul className="mt-2 p-0 text-white-50">
              <li><a className="link" href="#hero">Main</a></li>
              <li><a className="link" href="#services">Services</a></li>
              <li><a className="link" href="#about">About Us</a></li>
            </ul>
          </div>
          <div className="col-12 col-md-4 mb-2 text-center">
            <ul className="mt-2 p-0">
              <li>Analytic service</li>
              <li>ProfitPalms Analytics</li>
              <li>© {new Date().getFullYear()} All rights reserved</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
